export default __webpack_public_path__ + "static/english-express-llm-chatbot-c064a37fa0063fa6e02fca2b68a8aee4.png";